import { u as Environment } from "./Environment-DXNdmk85.js";
import * as Sentry from "@sentry/react";
// src/Logging/monitoring.ts
function getTracesSampleRate(environment) {
	return environment === Environment.PRODUCTION ? .1 : 1;
}
var COLOR_ERROR_ID_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
/**
* Sentry does generate a unique id, but it is too long for users to relay back to us.
* This generates a simple text string.
* @returns a reasonably unique and human readable string.
*/
var getRandomErrorId = () => {
	let errorId = "";
	for (let i = 0; i < 6; i += 1) {
		if (i !== 0 && i % 2 === 0) errorId += "-";
		errorId += COLOR_ERROR_ID_CHARACTERS[Math.floor(Math.random() * 26)];
	}
	return errorId;
};
var latestColorErrorId = "";
function getLatestSentryEventId() {
	return latestColorErrorId;
}
function initSentry(environment, config) {
	const { dsn } = config;
	if (!dsn) {
		console.warn("Unable to determine Sentry DSN");
		return;
	}
	const sentryOptions = {
		...config,
		environment,
		integrations: [Sentry.browserTracingIntegration()],
		denyUrls: [/cdn\.cookielaw\.org/i],
		tracesSampleRate: getTracesSampleRate(environment),
		beforeSend: (event) => {
			const colorErrorId = getRandomErrorId();
			latestColorErrorId = colorErrorId;
			return {
				...event,
				tags: {
					...event.tags,
					colorErrorId
				}
			};
		}
	};
	Sentry.init(sentryOptions);
}
var monitoringIsInitialized = false;
function initMonitoring(monitoringConfig) {
	if (monitoringIsInitialized) return;
	monitoringIsInitialized = true;
	const { environment, sentryConfig } = monitoringConfig;
	initSentry(environment, sentryConfig);
}
function getInstrumentedApp(App, monitoringConfig) {
	initMonitoring(monitoringConfig);
	return Sentry.withProfiler(App);
}
// src/Api/BaseApiError.ts
/**
* Raised when an error happens when trying make an API call.
*/
var BaseApiError = class extends Error {};
// src/Logging/captureUtils.ts
function captureException(error, otherProps) {
	Sentry.captureException(error, {
		level: "error",
		...otherProps
	});
}
function captureMessage(message, otherProps) {
	Sentry.captureMessage(message, {
		level: "info",
		...otherProps
	});
}
// src/Logging/loggerUtils.ts
var loggerUtils = {
	logMessageToConsole(message, ...optionalParameters) {
		console.log(message, ...optionalParameters);
	},
	logToConsole(error, extra) {
		console.error(error, extra);
	},
	logException(error, otherProps) {
		console.error(error, otherProps);
		if (!(error instanceof BaseApiError)) captureException(error, { ...otherProps });
	},
	logMessage(error, otherProps) {
		console.log(error, otherProps);
		captureMessage(error.message, { ...otherProps });
	}
};
export { initMonitoring as a, getLatestSentryEventId as i, BaseApiError as n, getInstrumentedApp as r, loggerUtils as t };

//# sourceMappingURL=Logging-SjeoN8aB.js.map